import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { formatSearchParams } from "../utils/helperFunctions";
import queryKeys from "./queryKeys";
const {
  createPayrollPolicy,
  getPayrollPolicy,
  createOrUpdateSalaryComponents,
  viewSalaryComponents,
  viewSalaryTemplateDetails,
  manageSalaryPolicyMapping,
  viewSalaryComponentDetails,
  assignPayrollPolicy,
  viewEmployeePayrollDetails,
  editSalaryTemplateDetails,
  viewPayrollPolicySalaryComponentDetails,
  generateEmployeePayslip,
  editEmployeeSalaryComponents,
  updateSalaryComponentActiveStatus,
  updatePayrollPolicyActiveStatus,
  viewEmployeeSalaryComponents,
  publishEmployeePayrollPolicy,
  generateEmployeePayrollPolicy,
  viewEmployeePayrollProcessSummary,
  viewEmployeePaySlipDetails,
  createStatutoryComponents,
  viewStatutoryComponents,
    viewLopSettings,
  enableLopSettings,
  updateSatutoryComponentActiveStatus,
  fetchEmployeeBankPayments,
  viewStatutoryComponentTypes,
  viewEmployeeGeneratedSalaryComponents,
  addOrUpdateEmployeeSalaryComponent,
} = queryKeys;
export const useGetPayrollPolicy = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [getPayrollPolicy, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/getPayrollPolicyList", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useCreatePayrollPolicy = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [createPayrollPolicy],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.post(
        "payroll/createPayrollPolicy",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([getPayrollPolicy]);
      }
    },
    onError: (error) => {},
  });
};

export const useCreateOrUpdateSalaryComponents = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [createOrUpdateSalaryComponents],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.post(
        "payroll/createOrUpdateSalaryComponents",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {},
  });
};
export const useViewSalaryComponents = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewSalaryComponents, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewSalaryComponents", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useManageSalaryPolicyMapping = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [manageSalaryPolicyMapping],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.post(
        "payroll/manageSalaryPolicyMapping",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {},
  });
};
export const useViewSalaryTemplateDetails = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();

  return useQuery({
    queryKey: [viewSalaryTemplateDetails, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewSalaryTemplateDetails", {
        params: formatedSearchParams,
      });
      return data;
    },
    enabled: !!params?.policy_id, 
  });
};


export const useViewSalaryComponentDetails = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewSalaryComponentDetails, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewSalaryComponentDetails", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useAssignPayrollPolicy = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [assignPayrollPolicy],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.post(
        "payroll/assignPayrollPolicy",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {},
  });
};
export const useGetEmployeePolicyPayrollList = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewSalaryComponentDetails, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/getEmployeePolicyPayrollList", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useViewEmployeePayrollDetails = (params = {}) => {

  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewEmployeePayrollDetails, params],
  
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewEmployeePayrollDetails", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useEditSalaryTemplateDetails = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [editSalaryTemplateDetails], 
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.put('payroll/editSalaryTemplateDetails', payload);
      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {
      
    },
  });
};

export const useViewPayrollPolicySalaryComponentDetailss = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewPayrollPolicySalaryComponentDetails, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewPayrollPolicySalaryComponentDetails", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useGenerateEmployeePayslipMutation = () => {
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationFn: async ({ employee_id,month,year }) => {
      const { data } = await axiosPrivate.get("/payroll/generateEmployeePayslip", {
        params: { employee_id,month,year },
      });
      return data;
    },
  });
};
export const useEditEmployeeSalaryComponents = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [editEmployeeSalaryComponents], 
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.put('payroll/editEmployeeSalaryComponents', payload);
      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponentDetails]);
      }
    },
    onError: (error) => {
      
    },
  });
};

export const useUpdatePayrollPolicyActiveStatus = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [updatePayrollPolicyActiveStatus], 
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.put('payroll/updatePayrollPolicyActiveStatus', payload);
      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([getPayrollPolicy]);
      }
    },
    onError: (error) => {
      
    },
  });
};

export const useUpdateSalaryComponentActiveStatus = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [updateSalaryComponentActiveStatus], 
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.put('payroll/updateSalaryComponentActiveStatus', payload);
      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([getPayrollPolicy]);
      }
    },
    onError: (error) => {
      
    },
  });
};
export const useViewEmployeeSalaryComponents = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewEmployeeSalaryComponents, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewEmployeeSalaryComponents", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};
export const useGenerateEmployeePayrollPolicy = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [generateEmployeePayrollPolicy],
    mutationFn: async (payload) => {

      const { data } = await axiosPrivate.post(
        "payroll/generateEmployeePayrollPolicy",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewEmployeeSalaryComponents]);
      }
    },
    onError: (error) => {},
  });
};
export const usePublishEmployeePayrollPolicy = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [publishEmployeePayrollPolicy],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.post(
        "payroll/publishEmployeePayrollPolicy",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewEmployeeSalaryComponents]);
      }
    },
    onError: (error) => {},
  });
};

export const useViewEmployeePayrollProcessSummary = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewEmployeePayrollProcessSummary, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewEmployeePayrollProcessSummary", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useViewEmployeePaySlipDetails = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewEmployeePaySlipDetails, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewEmployeePaySlipDetails", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};
export const useCreateOrUpdateStatutoryComponents = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [createStatutoryComponents],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.post(
        "payroll/createOrUpdateStatutoryComponents",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {},
  });
};
export const useViewStatutoryComponents = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewStatutoryComponents, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewStatutoryComponents", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};
export const useEnableLopSettings = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [enableLopSettings],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.post(
        "payroll/enableLopSettings",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewLopSettings]);
      }
    },
    onError: (error) => {},
  });
};
export const useViewLopSettings = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewLopSettings, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewLopSettings", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useUpdateSatutoryComponentActiveStatus = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [updateSatutoryComponentActiveStatus], 
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.put('payroll/updateSatutoryComponentActiveStatus', payload);
      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewStatutoryComponents]);
      }
    },
    onError: (error) => {
      
    },
  });
};
export const useGetFetchEmployeeBankPayments = (params = {}) => {
  const axiosPrivate = useAxiosPrivate();

  return useQuery({
    queryKey: [fetchEmployeeBankPayments, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/fetchEmployeeBankPayments", {
        params: {
          ...params, 
        },
      });
      return data;
    },
    enabled: !params.download, 
  });
};

export const useViewStatutoryComponentTypes = (params = {}) => {
  const axiosPrivate = useAxiosPrivate();

  return useQuery({
    queryKey: [viewStatutoryComponentTypes, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewStatutoryComponentTypes", {
        params: {
          ...params, 
        },
      });
      return data;
    },
 
  });
};

export const useViewEmployeeGeneratedSalaryComponents = (params = {}) => {
  const formatedSearchParams = formatSearchParams(params);
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [viewEmployeeGeneratedSalaryComponents, params],
    queryFn: async () => {
      const { data } = await axiosPrivate.get("payroll/viewEmployeeGeneratedSalaryComponents", {
        params: formatedSearchParams,
      });
      // console.log("data:",data)
      return data;
    },
  });
};

export const useCreateOrUpdateEmployeeSalaryComponents = () => {
  const queryClient = useQueryClient();
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationKey: [addOrUpdateEmployeeSalaryComponent],
    mutationFn: async (payload) => {
      const { data } = await axiosPrivate.put(
        "payroll/addOrUpdateEmployeeSalaryComponent",
        payload
      );

      return data;
    },
    onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {},
  });
};

export const useDeleteStatutoryComponents = () => {
  const axiosPrivate = useAxiosPrivate();
const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ component_id }) => {
      const { data } = await axiosPrivate.delete(
        "payroll/deleteStatutoryComponents",
        {
          params: { component_id },
        }
      );
      return data;
    },
     onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {},
  });

};
export const useDeleteSalaryComponents = () => {
  const axiosPrivate = useAxiosPrivate();
const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ component_id }) => {
      const { data } = await axiosPrivate.delete(
        "payroll/deleteSalaryComponents",
        {
          params: { component_id },
        }
      );
      return data;
    },
     onSuccess: (data) => {
      if (data?.status) {
        queryClient.invalidateQueries([viewSalaryComponents]);
      }
    },
    onError: (error) => {},
  });

};